import { supabase } from './supabase';

function lsKey(uid) {
  return 'previsr_stats_' + uid;
}

export async function loadStats(uid) {
  const { data, error } = await supabase
    .from('profiles')
    .select('mcat, gpa, sci_gpa, state')
    .eq('id', uid)
    .single();

  if (!error && data) {
    const stats = {
      mcat: data.mcat != null ? String(data.mcat) : '',
      gpa: data.gpa != null ? String(data.gpa) : '',
      sciGpa: data.sci_gpa != null ? String(data.sci_gpa) : '',
      state: data.state || '',
    };
    try { localStorage.setItem(lsKey(uid), JSON.stringify(stats)); } catch (_) {}
    return stats;
  }

  return getCachedStats(uid);
}

export async function saveStats(uid, stats) {
  await supabase
    .from('profiles')
    .update({
      mcat: stats.mcat ? parseInt(stats.mcat, 10) : null,
      gpa: stats.gpa ? parseFloat(stats.gpa) : null,
      sci_gpa: stats.sciGpa ? parseFloat(stats.sciGpa) : null,
      state: stats.state || null,
    })
    .eq('id', uid);

  try { localStorage.setItem(lsKey(uid), JSON.stringify(stats)); } catch (_) {}
}

export function getCachedStats(uid) {
  try {
    return JSON.parse(localStorage.getItem(lsKey(uid)) || '{}');
  } catch (_) {
    return {};
  }
}
